<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Contributions"
      text="Create Contributions"
      class="mb-0"
    >
      <v-stepper
        :value="stepper"
        :vertical="false"
        non-linear
      >
        <v-stepper-header>
          <span
            v-for="(step,i) in steps"
            :key="i"
          >
            <v-stepper-step
              :step="i + 1"
              :complete="i+1<stepper"
              editable
            >
              {{ step.name }}
            </v-stepper-step>

            <v-divider />
          </span>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content
            :vertical="false"
            :step="1"
          >
            <employee-profile-payroll-payroll-company-contribution-epf-container-view
              v-if="dialog"
              :company-employee-uid="companyEmployeeUid"
              @close-dialog="closeDialog"
              @created="emitCreated"
            />
          </v-stepper-content>

          <v-stepper-content
            :vertical="false"
            :step="2"
          >
            <employee-profile-payroll-payroll-company-contribution-socso-container-view
              v-if="dialog"
              :company-employee-uid="companyEmployeeUid"
              @close-dialog="closeDialog"
              @created="emitCreated"
            />
          </v-stepper-content>

          <v-stepper-content
            :vertical="false"
            :step="3"
          >
            <employee-profile-payroll-payroll-company-contribution-eis-container-view
              v-if="dialog"
              :company-employee-uid="companyEmployeeUid"
              @close-dialog="closeDialog"
              @created="emitCreated"
            />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollPayrollCompanyContributionEpfContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/contribution/epf/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyContributionSocsoContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/contribution/socso/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyContributionEisContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/contribution/eis/ContainerView'),
    },
    props: {
      companyEmployeeUid: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        stepper: 1,
        steps: [
          { 'name': 'EPF' },
          { 'name': 'SOCSO' },
          { 'name': 'EIS' },
        ],
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.stepper = 1
        }
      },
    },
    methods: {
      closeDialog () {
        this.dialog = false
      },
      emitCreated () {
        this.$emit('created')
      },
    },
  }
</script>
